import React from 'react';
import Page from 'components/Page';
import Tabs from '../components/VirgoolTabs';
import EditForm from './Form';
import VirgoolStatistics from './Statistics';

function Virgool({ location, match }) {
  const virgoolId = match.params.id;
  const activeTab = location.pathname.split('/')[3];

  return (
    <Page>
      <Tabs activeKey={activeTab} virgoolId={parseInt(virgoolId)} />

      <div hidden={activeTab !== 'edit'}>
        <EditForm virgoolId={virgoolId} />
      </div>

      <div hidden={activeTab !== 'statistics'}>
        <VirgoolStatistics virgoolId={virgoolId} />
      </div>
    </Page>
  );
}

export default Virgool;
